import { render } from "./SuggestionMatchLogInfo.vue?vue&type=template&id=7dfbdafc&scoped=true"
import script from "./SuggestionMatchLogInfo.vue?vue&type=script&lang=js"
export * from "./SuggestionMatchLogInfo.vue?vue&type=script&lang=js"

import "./SuggestionMatchLogInfo.vue?vue&type=style&index=0&id=7dfbdafc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfbdafc"]])

export default __exports__